<template>
  <div>
    <h3 class="header">{{title}}</h3>
    <div class="title">
      <div style="font-size:12px;margin:10px;color:gray">{{desc}}</div>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">姓名:</span>
        <span>
          <van-field
            style="width:150%"
            clearable
            v-model="question.username"
            placeholder="请输入真实姓名"
          />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">支行:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.branch" placeholder="请输入支行" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">部门:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.dep" placeholder="请输入部门" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">联系方式:</span>
        <span>
          <van-field style="width:150%" clearable v-model="question.mobile" placeholder="请输入手机号码" />
        </span>
      </van-cell-group>
      <h5>{{questions}}</h5>
      <van-radio-group v-model="radio" @change="change" v-for="(item,index) in items" :key="index">
        <van-radio :disabled="item.disabled" :name="item.id" class="radio">
          {{item.item}}
          <span style="color:gray">{{item.ext}}</span>
        </van-radio>
      </van-radio-group>

      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary" class="submit" @click="submitAnswer">提交答案</van-button>
      </div>
      <div class="footer">
        <!-- 吉林银行专属客户经理 -->
        <br />
        {{ad}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
import { wxzhuzi, wenjuan } from "../api/wenjuan";

export default {
  data() {
    return {
      radio: "2",
      items: [],
      title: "",
      questions: "",
      desc: "",
      ad: "",
      question: {
        id: "",
        answer: "",
        username: "",
        branch: "",
        dep: "",
        mobile: ""
      }
    };
  },
  methods: {
    change(val) {
      this.question.answer = val;
    },
    submitAnswer() {
      if (
        this.question.username == "" ||
        this.question.branch == "" ||
        this.question.dep == "" ||
        this.question.mobile == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else {
        this.$http.post("/oa/wxzhuzi/wenjuan", this.question).then(res => {
          this.$toast({
            message: res.data.message,
            type: "success",
            duration: 10000
          });
        });
        this.question = {};
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      this.$http.post("/oa/wxzhuzi/index?id=" + id).then(res => {
        this.items = res.data.data.items;
        this.title = res.data.data.title;
        this.questions = res.data.data.question;
        this.desc = res.data.data.desc;
        this.ad = res.data.data.ad;
        this.question.id = res.data.data.id;
        this.$route.query.id = res.data.data.id;
      });
      // this.$http.get("/oa/wxzhuzi/answer?id=" + id).then(res => {
      //   console.log(res);
      // });
    } else {
      const id = 1;
      this.$http.post("/oa/wxzhuzi/index?id=" + id).then(res => {
        this.items = res.data.data.items;
        this.title = res.data.data.title;
        this.questions = res.data.data.question;
        this.question.id = res.data.data.id;
        this.$route.query.id = res.data.data.id;
      });
      // this.$http.get("/oa/wxzhuzi/answer?id=" + id).then(res => {
      //   console.log(res);
      // });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 12px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/wenjuan.vue